import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Snackbar,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import MuiAlert from "@mui/material/Alert";
import {
  getCoveredMedicationsAndDrugsById,
  updateCoveredMedicationsAndDrugs,
} from "./../../ApiConfig.jsx";

const validationSchema = yup.object().shape({
  name: yup.string().required("Service is required"),
  reference: yup.string().required("Reference is required"),
  drugCategory: yup.string().required("Drug category name is required"),
  isCovered: yup.string().required("Covered is required"),
});

function EditCoveredMedicationsAndDrugs() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [status, setStatus] = useState("Inactive");
  const initialUserDetails = {
    name: "",
    reference: "",
    drugCategory: "",
    isCovered: "",
  };

  const [itemDetails, setItemDetails] = useState(initialUserDetails);
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchItemData = async (id) => {
    try {
      const data = await getCoveredMedicationsAndDrugsById(id);
      if (data.success==="true") {
        console.log(data.data);
        setStatus(data.data.status);
        setItemDetails({
          name: data.data.name,
          reference: data.data.reference,
          isCovered: data.data.isCovered,
          isCovered: data.data.isCovered,
          drugCategory: data.data.drugCategory,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchItemData(id);
  }, [id]);



  const validateField = (field, value) => {
    validationSchema
      .validateAt(field, { ...itemDetails, [field]: value })
      .then(() => {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
      })
      .catch((error) => {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: error.message }));
      });
  };

  const handleFieldChange = (field, value) => {
    setItemDetails((prevUserDetails) => ({
      ...prevUserDetails,
      [field]: value,
    }));
    validateField(field, value);
  };

  const updateHandler = async (userDetails) => {
    const hasErrors = Object.values(errors).some(
      (errorMessage) => errorMessage !== ""
    );

    if (hasErrors) {
      console.log("Errors found. Cannot update medication.");
      return;
    }

    console.log(userDetails);
    setIsLoading(true);
    const body = {
  ...userDetails,status
}
    try {
      const respondData = await updateCoveredMedicationsAndDrugs(id, body);
      console.log(respondData);
      if (respondData.success==="true") {
        setAlertSeverity("success");
        setAlertMessage("Medication edited successfully");
        setTimeout(() => {
          navigate("/CoveredMedicationsAndDrugsManagement");
        }, 2500);
      }
    } catch (err) {
      console.log(err);
      setAlertSeverity("error");
      setAlertMessage(`Failed to edit medication: ${err.message}`);
    } finally {
      setOpenSnackbar(true);
      setIsLoading(false);
    }
  };

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`Edit Medications and Drugs ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Name*
            </Typography>
            <TextField
              type="text"
              fullWidth
              variant="filled"
              value={itemDetails.name}
              onChange={(e) => handleFieldChange("name", e.target.value)}
              error={!!errors.name}
              helperText={errors.name}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Reference*
            </Typography>
            <TextField
              type="text"
              fullWidth
              variant="filled"
              value={itemDetails.reference}
              onChange={(e) => handleFieldChange("reference", e.target.value)}
              error={!!errors.reference}
              helperText={errors.reference}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Drug category*
            </Typography>
            <TextField
              type="text"
              fullWidth
              variant="filled"
              value={itemDetails.drugCategory}
              onChange={(e) =>
                handleFieldChange("drugCategory", e.target.value)
              }
              error={!!errors.drugCategory}
              helperText={errors.drugCategory}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Covered*
            </Typography>
            <FormControl fullWidth variant="filled">
              <Select
                value={itemDetails.isCovered}
                onChange={(e) => handleFieldChange("isCovered", e.target.value)}
                name="isCovered"
                error={!!errors.isCovered}>
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {errors.isCovered && (
                <Typography variant="caption" color="error">
                  {errors.isCovered}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6870fa",
                color: "white",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#3e4396",
                },
              }}
              onClick={() => updateHandler(itemDetails)}>
              {isLoading ? "Updating..." : "Update"}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity={alertSeverity}
          elevation={6}
          variant="filled"
          style={{ color: "white" }}>
          {alertSeverity === "success" ? "Success" : "Error"}
          {": "}
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
}

export default EditCoveredMedicationsAndDrugs;
